(function() {    
function storeCollection(collectionHandle, collectionTitle, collectionUrl) {
    const data = {
    handle: collectionHandle,
    title: collectionTitle,
    url: collectionUrl,
    timestamp: Date.now()
    };
    localStorage.setItem('selected_collection', JSON.stringify(data));
}

function findCollectionFromElement(element) {
    let currentElement = element;
    let depth = 0;
    
    while (currentElement && depth < 10) {
    if (currentElement.tagName && currentElement.tagName.toLowerCase() === 'featured-collection') {
        const handle = currentElement.getAttribute('data-collection-handle');
        const title = currentElement.getAttribute('data-collection-title');
        const url = currentElement.getAttribute('data-collection-url');
        
        if (handle && title) {
        return { handle, title, url: url || `/collections/${handle}` };
        }
    }
    
    const handleAttr = currentElement.getAttribute ? currentElement.getAttribute('data-collection-handle') : null;
    if (handleAttr) {
        const titleAttr = currentElement.getAttribute('data-collection-title');
        const urlAttr = currentElement.getAttribute('data-collection-url');
        if (handleAttr && titleAttr) {
        return { handle: handleAttr, title: titleAttr, url: urlAttr || `/collections/${handleAttr}` };
        }
    }
    
    currentElement = currentElement.parentElement;
    depth++;
    }
    return null;
}

function trackProductClicks() {
    const productLinks = document.querySelectorAll('a[href*="/products/"]');
    
    productLinks.forEach(link => {
    if (link.hasAttribute('data-collection-tracker')) return;
    
    link.addEventListener('click', function(e) {
        
        const urlMatch = this.href.match(/\/collections\/([^\/?]+)/);
        if (urlMatch && urlMatch[1]) {
        const handle = urlMatch[1];
        const title = handle.replace(/-/g, ' ');
        storeCollection(handle, title, `/collections/${handle}`);
        return;
        }
        
        const collection = findCollectionFromElement(this);
        if (collection) {
        storeCollection(collection.handle, collection.title, collection.url);
        }
    });
    
    link.setAttribute('data-collection-tracker', 'true');
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackProductClicks);
} else {
    trackProductClicks();
}

const observer = new MutationObserver(() => {
    trackProductClicks();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
})();